export default __webpack_public_path__ + "static/media/transfusion-scalp.081a9282.jpg";